import { onDocumentReady, onContentReady, Carousel } from "@story/story_assets";

import "@story/story_assets/snippets";
import "@story/story_assets/slide";
// require story_assets/slide


import { Modal } from "@story/story_assets/modal/modal";
import "@story/story_assets/modal/modal_dialog";
import "@story/story_assets/modal/modal_gallery";

import "./components/active_group";
import "./components/remote_links";
import "./components/page_switch";
import "./components/images";
import "./components/masonry_filter";

import Parallax from "./components/parallax";
import Eraser from "./components/eraser";


onDocumentReady(function() {
	for (let eraser of document.querySelectorAll(".eraser")) {
		new Eraser(eraser);
	}

	for (let parallax of document.querySelectorAll(".parallax")) {
		new Parallax(parallax);
	}
});

onContentReady(function(parent) {
	for (let carousel of parent.querySelectorAll(".carousel")) {
		new Carousel(carousel);
	}
});


//
// Reference modals
//
document.addEventListener("snippetready", function(event) {
	let parent = event.detail.parent;
	if (parent.matches(".modal.modal-reference")) {
		for (let element of document.querySelectorAll(".modal.modal-reference")) {
			if (element != parent) {
				// Animation.fadeOut(element).then(function() {
				Modal.get(element).close();
				// });
			}
		}
	}
});
